<template>
    <MobileHeader
        v-if="leagueInfo.isFavLeague !== undefined"
        :isShowFavButton="scrollTop >= 45.59"
        :isFav="isFavLeague"
        :mobileFilterPill="
            currentTabs === 2
                ? mobileStandingSeasonFilter
                : mobileResultsSeasonFilter
        "
        @toggleFavThis="toggleFavLeague($event)"
        @filterPillIsReady="mobileFilterPillIsReady"
    >
    </MobileHeader>

    <div :class="!isMobile ? 'home' : ''">
        <!-- <Banner v-if="!isMobile"></Banner> -->

        <div class="container home-nav__containers mb-1rem home-box">
            <template v-if="isMobile">
                <Sticky
                    :top="2"
                    :show="49"
                    :stickyShowBefore="false"
                    stickyStyle="width: 44px;left: 50%;transform: translate3D(-50%, 0 , 0)"
                >
                    <leagueIcon
                        :icon="leagueInfo.leagueKey"
                        className="mr-05rem icon-league scroll_top_logo_size"
                    >
                        <Icon
                            :logoUrl="leagueInfo.logo"
                            class="scroll_top_logo_size"
                        ></Icon>
                    </leagueIcon>
                </Sticky>
            </template>
            <div class="league-header" :class="`league-${currentTabs}`">
                <div
                    v-if="isMobile"
                    class="display-flex-align-center league-header__wrapper"
                >
                    <div>
                        <leagueIcon
                            :icon="leagueInfo.leagueKey"
                            className="mr-05rem icon-league"
                        >
                            <Icon
                                :logoUrl="leagueInfo.logo"
                                class="mr-05rem icon-league"
                            ></Icon>
                        </leagueIcon>
                    </div>
                    <div class="w-100">
                        <p
                            class="home-match__title-country"
                            v-if="!!leagueInfo.leagueName"
                            :class="scrollTop > 100 ? 'center-display' : ''"
                        >
                            {{ $t(leagueInfo.country) }}
                        </p>
                        <p
                            class="home-match__title home-match__title-mobile"
                            v-else
                            :class="scrollTop > 100 ? 'center-display' : ''"
                        >
                            {{ $t(leagueInfo.country) }}
                        </p>
                        <h2 class="home-match__title home-match__title-mobile">
                            {{ $t(leagueInfo.leagueName) }}
                        </h2>
                    </div>
                    <FavStarButton
                        v-if="
                            leagueInfo.isFavLeague !== undefined &&
                            scrollTop < 45.59
                        "
                        class="enabled flex-shrink"
                        :isFav="isFavLeague"
                        :isCircle="true"
                        @toggleFavThis="toggleFavLeague($event)"
                    >
                    </FavStarButton>
                </div>
                <!--tabs display-->
                <div
                    v-if="!isMobile"
                    class="display-flex-sb display-flex-align-start"
                >
                    <div class="display-flex-align-center tab-wrapper">
                        <div class="mr-1rem">
                            <leagueIcon
                                :icon="leagueInfo.leagueKey"
                                className="mr-05rem league-icon"
                            >
                                <Icon
                                    :logoUrl="leagueInfo.logo"
                                    class="mr-05rem league-icon"
                                ></Icon>
                            </leagueIcon>
                        </div>
                        <div>
                            <!-- <span class="btn-fav enabled"></span> -->
                            <h2 class="league-title display-flex-sb">
                                <span class="mr-05rem">{{
                                    $t(leagueInfo.leagueName)
                                }}</span>
                                <div
                                    class="btn-fav-aspn-circle pointer"
                                    v-if="leagueInfo.isFavLeague !== undefined"
                                    @click="toggleFavLeague($event)"
                                    :class="{
                                        selected: isFavLeague,
                                    }"
                                ></div>
                                <!-- <FavStarButton
                  v-if="leagueInfo.isFavLeague !== undefined"
                  class="btn-fav-aspn enabled"
                  :isFav="isFavLeague"
                  @toggleFavThis="toggleFavLeague($event)"
                >
                </FavStarButton> -->
                            </h2>
                            <p class="league-title__country">
                                {{ $t(leagueInfo.country) }}
                            </p>
                        </div>
                    </div>
                    <div
                        v-show="currentPrimaryTabs === 1"
                        class="display-flex-align-end flex-col"
                    >
                        <div v-show="selectedCurrentChildMenu === 'results'">
                            <div
                                class="nav-pill__wrapper filter-pill display-flex-center z-index-10"
                            >
                                <div class="relative">
                                    <div
                                        class="nav-pill btn-aspn-only-default season-button display-flex-center"
                                        :class="{
                                            selected: currentSeasonList.colored,
                                        }"
                                        @click="handleSeasonBtn($event)"
                                    >
                                        <span class="mr-05rem">{{
                                            currentSeasonList.name.replace(
                                                "-",
                                                "/"
                                            )
                                        }}</span>
                                        <i
                                            class="svg-arrow__vertical"
                                            :class="{
                                                selected:
                                                    currentSeasonList.colored,
                                            }"
                                        >
                                            <svg
                                                width="13"
                                                height="8"
                                                viewBox="0 0 13 8"
                                                class="league-dropdown__svg"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1.74042 0.589996L6.53499 5.17L11.3296 0.589996L12.8024 2L6.53499 8L0.267578 2L1.74042 0.589996Z"
                                                    fill="inherit"
                                                />
                                            </svg>
                                        </i>
                                    </div>

                                    <div
                                        class="dropdown-wrapper z-index-10"
                                        :class="{
                                            selected:
                                                currentSeasonList.isShowDropdown,
                                        }"
                                    >
                                        <perfect-scrollbar>
                                            <div
                                                class="dropdown-container__wrapper"
                                            >
                                                <div
                                                    class="dropdown-container"
                                                    :class="{
                                                        selected: o.selected,
                                                    }"
                                                    v-for="(
                                                        o, index
                                                    ) in seasonList"
                                                    :key="index"
                                                    @click="
                                                        handleSeasonDropdown(
                                                            o,
                                                            false
                                                        )
                                                    "
                                                >
                                                    <div
                                                        class="dropdown-container__name"
                                                    >
                                                        <span
                                                            >{{
                                                                o.season.replace(
                                                                    "-",
                                                                    "/"
                                                                )
                                                            }}
                                                        </span>
                                                    </div>
                                                    <!-- <div
                            class="dropdown-container__tick"
                            :class="{ selected: o.selected }"
                          ></div> -->
                                                    <TickMark
                                                        v-if="o.selected"
                                                    />
                                                </div>
                                            </div>
                                        </perfect-scrollbar>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="nav-pill__wrapper filter-pill display-flex mt-s"
                            v-if="subLeagueList.length > 1"
                        >
                            <div class="relative">
                                <div
                                    class="nav-pill display-flex-center btn-aspn-only-default season-button"
                                    :class="{ selected: true }"
                                    @click="handleSubLeagueBtn($event)"
                                >
                                    <span class="mr-1rem">{{
                                        $t(currentSubLeague.subLeagueName)
                                    }}</span>
                                    <i
                                        class="svg-arrow__vertical"
                                        :class="{
                                            selected: currentSubLeague.colored,
                                        }"
                                    >
                                        <svg
                                            width="13"
                                            height="8"
                                            viewBox="0 0 13 8"
                                            class="league-dropdown__svg"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M1.74042 0.589996L6.53499 5.17L11.3296 0.589996L12.8024 2L6.53499 8L0.267578 2L1.74042 0.589996Z"
                                                fill="inherit"
                                            />
                                        </svg>
                                    </i>
                                </div>

                                <div
                                    class="dropdown-wrapper"
                                    :class="{
                                        selected:
                                            currentSubLeague.isShowDropdown,
                                    }"
                                >
                                    <perfect-scrollbar>
                                        <div
                                            class="dropdown-container__wrapper"
                                        >
                                            <div
                                                class="dropdown-container"
                                                v-for="(
                                                    o, index
                                                ) in subLeagueList"
                                                :key="index"
                                                @click="
                                                    handleSubLeagueDropdown(
                                                        o,
                                                        false
                                                    )
                                                "
                                            >
                                                <div
                                                    class="dropdown-container__name"
                                                >
                                                    <span>{{
                                                        $t(o.subLeagueName)
                                                    }}</span>
                                                </div>
                                                <!-- <div
                          class="dropdown-container__tick"
                          :class="{ selected: o.selected }"
                        ></div> -->
                                                <TickMark v-if="o.selected" />
                                            </div>
                                        </div>
                                    </perfect-scrollbar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!isMobile" class="display-flex mb-1rem mt-m">
                    <div
                        class="sub-nav__child"
                        :class="{ selected: o.selected }"
                        v-for="(o, index) in primaryTabs"
                        :key="index"
                        @click="selectPrimaryTabs(o)"
                    >
                        <span class="sub-nav__child-text">{{
                            $t(o.name)
                        }}</span>
                        <div class="sub-nav__child-indicator"></div>
                    </div>
                </div>
            </div>

            <Sticky :top="48" :show="48" :stickyShowBefore="true" ref="sticky4">
                <div class="scroll_top_nav" :class="`nav-${currentTabs}`">
                    
                    <div
                        v-if="isMobile"
                        class="display-flex-center overflow-x"
                        :class="`league-tab-${currentTabs}`"
                    >
                        <div
                            class="sub-nav__child"
                            :class="{ selected: o.selected }"
                            v-for="(o, index) in tabs"
                            :key="index"
                            @click="selectTabs(o)"
                        >
                            <span class="sub-nav__child-text nowrap">{{
                                $t(o.name)
                            }}</span>
                            <div class="sub-nav__child-indicator"></div>
                        </div>
                    </div>

                    <template v-if="currentTabs === 1 && isMobile">
                        <div
                            class="nav-pill__wrapper filter-pill league-matchtabs__wrapper"
                            :class="[
                                        { selected: true },
                                        currentSubLeague.colored
                                            ? 'mobile-select-container-dropdown-active'
                                            : 'mobile-select-container-dropdown-inactive',
                                    ]"
                            v-if="subLeagueList.length > 1"
                        >
                            <div id="subLeagueId" class="nav-pill display-flex-center btn-aspn-only-default">
                                <div
                                    
                                        class=""
                                    
                                >
                                    {{ $t(currentSubLeague.subLeagueName) }}
                                </div>
                                <SvgIcon icon="c.header.newsCaret"></SvgIcon>
                            </div>
                        </div>
                    </template>

                    <div
                        v-if="isMobile && currentChildMenus.length > 0"
                        class="nav-pill__wrapper sub-nav__child mt-s">
                        <div
                            class="nav-pill"
                            :class="{ selected: o.selected }"
                            v-for="(o, index) in currentChildMenus"
                            :key="index"
                            @click="selectChildMenu(o, currentChildMenus)"
                        >
                            {{ $t(o.name) }}
                        </div>
                    </div>

                    
                    
                </div>
                
            </Sticky>

            <!--content display-->
            <div v-if="!isMobile">
                <div
                    v-show="currentPrimaryTabs === 1"
                    class="display-flex row-wrap"
                >
                    <div class="league-match-listing-container">
                        <div class="league-container-title">
                            {{ $t("MATCHES") }}
                        </div>
                        <div class="nav-pill__wrapper sub-nav__child mb-05rem">
                            <div
                                class="nav-pill btn-aspn-default"
                                :class="{ selected: o.selected }"
                                v-for="(o, index) in matchesSubmenus"
                                :key="index"
                                @click="selectChildMenu(o, matchesSubmenus)"
                            >
                                {{ $t(o.name) }}
                            </div>
                        </div>

                        <MatchContent
                            ref="matchContentChild"
                            class="match-content__wrapper league"
                            style="min-height: 15rem"
                            type="league"
                            @changeMatchContentEvent="
                                changeMatchContentFixtureByLeagueEvent($event)
                            "
                        ></MatchContent>
                    </div>
                    <div class="flex-1" v-show="!isMobile">
                        <div
                            v-show="!isShowNoDataTable"
                            class="match-table-container"
                        >
                            <div>
                                <div class="match-table__header">
                                    <div class="standing-title">
                                        {{ $t("STANDINGS") }}
                                    </div>
                                    <div class="nav-pill__wrapper">
                                        <div
                                            class="nav-pill btn-aspn-default"
                                            :class="{ selected: o.selected }"
                                            v-for="(o, index) in tableTabs"
                                            :key="index"
                                            @click="selectTableTabs(o)"
                                        >
                                            {{ $t(o.name) }}
                                        </div>
                                    </div>
                                </div>

                                <div v-show="currentTableTabs === 'total'">
                                    <MatchTable
                                        :isShowTabs="false"
                                        :type="'total'"
                                        :matchTableListData="matchTableList"
                                    ></MatchTable>
                                </div>
                                <div v-show="currentTableTabs === 'home'">
                                    <MatchTable
                                        :isShowTabs="false"
                                        :type="'home'"
                                        :matchTableListData="matchTableList"
                                    ></MatchTable>
                                </div>
                                <div v-show="currentTableTabs === 'away'">
                                    <MatchTable
                                        :isShowTabs="false"
                                        :type="'away'"
                                        :matchTableListData="matchTableList"
                                    ></MatchTable>
                                </div>
                                <div v-show="currentTableTabs === 'form'">
                                    <MatchTable
                                        :isShowTabs="false"
                                        :type="'form'"
                                        :matchTableListData="matchTableList"
                                    ></MatchTable>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="league-about__container" v-if="!isNoData">
              <h2 class="league-about__title">{{ $t("ABOUT") }}</h2>
              <p class="league-about__content">{{ aboutContent }}</p>
            </div> -->
                    </div>
                </div>
                <div
                    v-show="currentPrimaryTabs === 2"
                    class="display-flex row-wrap"
                >
                    <LeagueNews />
                </div>
            </div>

            <div v-if="isMobile">
                <div v-show="currentTabs === 1" class="has-space">
                    <teleport to="league-match-group"> </teleport>

                    <!-- <div class="display-flex-sb match-table__header">
            
              <div
                v-if="subLeagueList.length > 1"
                class="league-matchtabs__seperator"
              ></div>
              <DatePicker
                v-model="montlyCalenderModel"
                color="#6F8C9B"
                is-dark
                firstDayOfWeek="1"
                :locale="
                  currentLocale === 'vn'
                    ? 'vi'
                    : currentLocale && currentLocale === 'cn'
                    ? 'zh'
                    : currentLocale
                "
                class="capitalize"
              >
                <template #default="{ inputValue, togglePopover, hidePopover }">
                  <div
                    class="nav-pill"
                    :class="{ selected: montlyCalender.selected }"
                    @click.stop="
                      monthlyCalendarHandle(
                        $event,
                        date,
                        togglePopover,
                        hidePopover
                      )
                    "
                  >
                    <span v-if="montlyCalender.date === 'DATE'">
                      {{ $t(montlyCalender.date) }}</span
                    >
                    <span v-else> {{ montlyCalender.date }}</span>
                  </div>
                </template>
              </DatePicker>
              <div
                class="nav-pill"
                v-for="(o, index) in matchOptions"
                :key="index"
                :class="{ selected: o.selected }"
                @click="handleMatchOptions(o)"
              >
                {{ $t(o.name) }}
              </div>
              <div>
                <span class="league-matchtabs__reset" @click="handleReset()">{{
                  $t("RESET")
                }}</span>
              </div>
            </div>
          </div> -->
                    <!-- <div class="match-filter__date mb-main"> -->
                    <!-- <div ><span class="match-filter__child" @click="handleClearDate()">{{$t('CLEAR')}}</span></div> -->
                    <!-- </div> -->
                    <!-- <MatchContent
				ref="matchContentChild"
				class="match-content__wrapper"
				style="min-height: 15rem"
				type="league"
				@changeMatchContentEvent="changeMatchContentFixtureByLeagueEvent($event)"
			></MatchContent> -->
                    <!-- <FixtureLeagueContent
            class="match-content__wrapper "
            :params="leagueListParams"
            @changeMatchContentFixtureByLeagueEvent="
              changeMatchContentFixtureByLeagueEvent($event)
            "
          ></FixtureLeagueContent> -->
                </div>

                <!-- <div v-show="selectedCurrentChildMenu === 'results'">
          <div class="display-flex-sb match-table__header">
            <div class="nav-pill__wrapper league-matchtabs__wrapper">
              <div
                id="seasonListId"
                class="nav-pill selected"
                :class="[
                  { selected: currentSeasonList.colored },
                  currentSeasonList.colored
                    ? 'mobile-select-container-dropdown-active'
                    : 'mobile-select-container-dropdown-inactive',
                ]"
              >
                <span>{{ currentSeasonList.name }}</span> -->
                <!-- <i
                  class="svg-arrow__vertical"
                  :class="{ selected: currentSeasonList.isShowDropdown }"
                >
                  <svg
                    width="13"
                    height="8"
                    viewBox="0 0 13 8"
                    class="league-dropdown__svg"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.74042 0.589996L6.53499 5.17L11.3296 0.589996L12.8024 2L6.53499 8L0.267578 2L1.74042 0.589996Z"
                      fill="inherit"
                    />
                  </svg>
                </i> -->
                <!-- </div>
            </div>
          </div> -->
                <!-- <MatchContent
				ref="matchContentChild"
				class="match-content__wrapper "
				style="min-height: 15rem"
				type="league"
				@changeMatchContentEvent="changeMatchContentFixtureByLeagueEvent($event)"
			></MatchContent> -->
                <!-- <FixtureLeagueContent
            class="match-content__wrapper mr-2rem"
            :params="leagueListSeasonParams"
            @changeMatchContentFixtureByLeagueEvent="
              changeMatchContentFixtureByLeagueEvent($event)
            "
          ></FixtureLeagueContent> -->
                <!-- </div> -->
                <div v-show="currentTabs === 2" class="has-space">
                    <div>
                        <div
                            class="display-flex-sb match-table__header"
                            style="display: none"
                        >
                            <div class="nav-pill__wrapper">
                                <div
                                    id="seasonListStandingsId"
                                    class="nav-pill btn-aspn-only-default"
                                    :class="[
                                        { selected: true },
                                        currentSeasonList.colored
                                            ? 'mobile-select-container-dropdown-active'
                                            : 'mobile-select-container-dropdown-inactive',
                                    ]"
                                >
                                    <span>{{ currentSeasonList.name }}</span>
                                    <SvgIcon
                                        icon="c.header.newsCaret"
                                    ></SvgIcon>
                                </div>

                                <div class="nav-pill-group-divider"></div>
                            </div>
                        </div>

                        <div v-show="isShowLoading" class="standing-box mx-0">
                            <LoadingAspn type="standings" />
                        </div>
                        <div v-show="!isShowLoading">
                            <div v-show="!isShowNoDataTable">
                                <div v-show="currentTableTabs === 'total'">
                                    <MatchTable
                                        :isShowTabs="false"
                                        :type="'total'"
                                        :matchTableListData="matchTableList"
                                    ></MatchTable>
                                </div>
                                <div v-show="currentTableTabs === 'home'">
                                    <MatchTable
                                        :isShowTabs="false"
                                        :type="'home'"
                                        :matchTableListData="matchTableList"
                                    ></MatchTable>
                                </div>
                                <div v-show="currentTableTabs === 'away'">
                                    <MatchTable
                                        :isShowTabs="false"
                                        :type="'away'"
                                        :matchTableListData="matchTableList"
                                    ></MatchTable>
                                </div>
                                <div v-show="currentTableTabs === 'form'">
                                    <MatchTable
                                        :isShowTabs="false"
                                        :type="'form'"
                                        :matchTableListData="matchTableList"
                                    ></MatchTable>
                                </div>
                            </div>
                        </div>
                        <NoData v-show="isShowNoDataTable" />
                        <!-- <div class="no-data">
              {{ $t("NO_DATA") }}
            </div> -->
                    </div>
                </div>
                <div v-show="currentTabs === 3">
                    <LeagueNews ref="leagueNews" />
                </div>
                <div v-show="currentTabs === 4" class="pa-05rem">
                    <LeagueStats />
                </div>

                <MatchContent
                    v-show="currentTabs === 1"
                    ref="matchContentChild"
                    class="match-content__wrapper"
                    style="min-height: 15rem"
                    type="league"
                    @changeMatchContentEvent="
                        changeMatchContentFixtureByLeagueEvent($event)
                    "
                ></MatchContent>
            </div>
        </div>
    </div>

    <PopUpSignInIndexMobile
        ref="PopUpSignInIndexMobileRef"
        :title="$i18n.t('FAV_LOGIN_TITLE')"
        :message="$i18n.t('FAV_LOGIN_TIPS')"
        class="login-fav-popup"
    ></PopUpSignInIndexMobile>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import moment from "moment";
import MobileSelect from "mobile-select"; //"@/lib/mobile-select"
import { DatePicker } from "@/lib/v-calendar";

import MobileHeader from "@/components/mobile/Header.vue";
import MatchContent from "@/components/MatchContent3.vue";
import MatchTable from "@/components/match/football/Table.vue";
import Banner from "@/components/Banner.vue";
import config from "@/js/config.js";
import about from "@/js/about/league.js";
import FavStarButton from "@/components/ui/FavStarButton.vue";
import ModalPopup from "@/components/modal/ModalPopup.vue";
import PopUpSignInIndexMobile from "@/components/user/PopUpSignInIndexMobile.vue";
import TickMark from "@/components/indicator/TickMark.vue";
import LeagueNews from "./News.vue";
import LeagueStats from "./Stats.vue";
import leagueIcon from "@/components/Icon/LeagueIcon.vue";

const DATE = "DATE";
let hideToggleElement;
let hideToggleTarget;
let mobileSelectSubLeague; // defined mobile select dropdown component for subLeague
let mobileSelectSeason; // defined mobile select dropdown component for season
export default {
    name: "Home",
    components: {
        MatchContent,
        MatchTable,
        MobileHeader,
        Banner,
        DatePicker,
        FavStarButton,
        ModalPopup,
        PopUpSignInIndexMobile,
        TickMark,
        LeagueNews,
        LeagueStats,
        leagueIcon,
    },
    data() {
        return {
            displayDateFormat: config.displayDateFormat,
            apiParamDateFormat: config.apiParamDateFormat,
            displayCNDateFormat: config.displayCNDateFormat,
            cnLocaleList: config.cnLocaleList,
            montlyCalender: {
                date: DATE,
                dateValue: "",
                selected: false,
                isFirstime: false,
            },
            montlyCalenderModel: "",
            selectedDate: {}, //date

            isShowClearBtn: false, //date

            leagueInfo: {
                leagueName: "",
                country: "",
            },
            mobileHeaderTitle: "COMPETITION",
            mobileSubHeaderTitle: "",

            mobileResultsSeasonFilter: {
                id: "seasonListId",
                show: false,
                content: "",
            },
            mobileStandingSeasonFilter: {
                id: "seasonListStandingsId",
                show: false,
                content: "",
            },

            tabs: [
                {
                    name: "MATCHES",
                    id: 1,
                    selected: true,
                },
                {
                    name: "STANDINGS",
                    id: 2,
                    selected: false,
                    child: [
                        {
                            name: "ALL",
                            id: "total",
                            selected: true,
                        },
                        {
                            name: "HOME",
                            id: "home",
                            selected: false,
                        },
                        {
                            name: "AWAY",
                            id: "away",
                            selected: false,
                        },
                        {
                            name: "FORM",
                            id: "form",
                            selected: false,
                        },
                    ],
                },

                {
                    name: "NEWS",
                    id: 3,
                    selected: false,
                },
                // {
                //   name: "STATS",
                //   id: 4,
                //   selected: false,
                //   child: [
                //     {
                //       name: "PLAYER_STATS",
                //       id: "player-stats",
                //       selected: true,
                //     },
                //     {
                //       name: "TEAM_STATS",
                //       id: "team-stats",
                //       selected: false,
                //     },
                //   ],
                // },
            ],
            primaryTabs: [
                {
                    name: "OVERVIEW",
                    id: 1,
                    selected: true,
                },
                {
                    name: "NEWS",
                    id: 2,
                    selected: false,
                },
                // {
                //   name: "PLAYER_STATS",
                //   id: 3,
                //   selected: false,
                // },
                // {
                //   name: "TEAM_STATS",
                //   id: 4,
                //   selected: false,
                // },
            ],

            matchesSubmenus: [
                {
                    name: "FIXTURES",
                    id: "fixtures",
                    selected: true,
                },
                {
                    name: "RESULTS",
                    id: "results",
                    selected: false,
                },
            ],

            tableTabs: [
                {
                    name: "ALL",
                    id: "total",
                    selected: true,
                },
                {
                    name: "HOME",
                    id: "home",
                    selected: false,
                },
                {
                    name: "AWAY",
                    id: "away",
                    selected: false,
                },
                {
                    name: "FORM",
                    id: "form",
                    selected: false,
                },
            ],

            currentTabs: 1, //mobile default show first 1
            currentPrimaryTabs: 1, //mobile default show first 1
            currentTableTabs: "total", //default show first 1
            currentChildMenus: [],
            selectedCurrentChildMenu: "fixtures",

            matchTableList: [],
            isLoading: false,
            isShowNoDataTable: true,
            isNoData: true,

            leagueListParams: {
                leagueKey: "",
                matchDate: "",
            },

            rankingTable: {
                isShow: false,
                isShowArrow: true,
                isLoading: false,
                currentSelectedLeagueIndex: 0,
                list: [],
                currentSelectedLeague: "",
            },

            aboutContent: "",

            matchOptions: [
                {
                    name: "UPCOMING",
                    selected: false,
                    type: 1,
                },
                {
                    name: "MOST_RECENT",
                    selected: false,
                    type: 2,
                },
            ],
            isFirstTimeGetFixtureLeagueData: true,

            fixtureByLeagueDataInterval: null,
            isCallMatchContentInterval: false,

            subLeagueList: [
                //subleague list
                {
                    subLeagueName: "ALL_GROUPS",
                    subLeagueId: "",
                    selected: false,
                },
            ],
            seasonList: [],
            currentSubLeague: {
                subLeagueName: "",
                isShowDropdown: false,
                colored: false,
            },
            currentSeasonList: {
                name: "",
                isShowDropdown: false,
                colored: true, //false
            },
            updateKey: false,

            isFavLeague: false,
            isResetMatchOptions: false,
            isShowLoading: true,
        };
    },
    watch: {
        isMobileRealTime(isMobile) {
            this.isResetMatchOptions = false;
            this.selectTabs(this.tabs[0]);
            this.init();
        },
        $route() {
            if (this.montlyCalender.dateValue != "") {
                if (this.cnLocaleList.includes(this.currentLocale)) {
                    this.montlyCalender.date = moment(
                        this.montlyCalender.dateValue
                    ).format(this.displayCNDateFormat);
                } else {
                    this.montlyCalender.date = moment(
                        this.montlyCalender.dateValue
                    ).format(this.displayDateFormat);
                }
            }
        },
        leagueDatePickercallback(newVal, oldVal) {
            let indexArr = newVal.indexArr;
            let data = newVal.data;

            that.currentSeasonList.name = data[0].value;
            that.currentSeasonList.id = data[0].id;

            // if (that.currentSeasonList.id === "null") {
            //   that.currentSeasonList.colored = false;
            // } else {
            that.currentSeasonList.colored = true;
            this.SET_LEAGUE_SEASON_LIST(this.currentSeasonList);
            // }

            if (type === "standings") {
                if (that.currentSeasonList.id !== "null") {
                    that.getPastSoccerLeagueRankingData(
                        that.currentSeasonList.name
                    );
                } else {
                    that.getSoccerLeagueRankingData();
                }
            } else {
                let isGetSeasonData = true;
                that.getFixtureByLeagueData(isGetSeasonData);
            }

            //default first option value
            this.currentSeasonList.name = mobileSelectData[0].value;
            this.SET_LEAGUE_SEASON_LIST(this.currentSeasonList);
            mobileSelectSeason.locatePosition(0, 0);

            if (type === "standings") {
                this.getSoccerLeagueRankingData();
            } else {
                let isGetSeasonData = true;
                this.getFixtureByLeagueData(isGetSeasonData);
            }
        },
        montlyCalenderModel: {
            deep: true,
            handler(newVal, oldVal) {
                if (newVal !== DATE) {
                    if (typeof hideToggleElement !== "undefined") {
                        setTimeout(
                            () => hideToggleElement({ ref: hideToggleTarget }),
                            500
                        ); // noob fix vcalendar bug (somethimes dont close the calendar automatic);
                    }

                    if (this.cnLocaleList.includes(this.currentLocale)) {
                        this.montlyCalender.date = moment(
                            newVal === null ? oldVal : newVal
                        ).format(this.displayCNDateFormat); //for montly calendar usage
                    } else {
                        this.montlyCalender.date = moment(
                            newVal === null ? oldVal : newVal
                        ).format(this.displayDateFormat); //for montly calendar usage
                    }
                    // this.montlyCalender.date = moment(
                    //   newVal === null ? oldVal : newVal
                    // ).format(this.displayDateFormat);
                    this.montlyCalender.dateValue =
                        newVal === null ? oldVal : newVal;
                    this.montlyCalenderModel =
                        newVal === null ? oldVal : newVal;

                    //this.isShowClearBtn = true;

                    this.montlyCalender.selected = true;
                    this.handleResetMatchOptions();

                    this.getFixtureByLeagueData();
                }
            },
        },
        currentLocale(newValue, oldValue) {
            // this.selectPrimaryTabs();
            this.isResetMatchOptions = false;
            this.selectTabs(this.tabs[0]);
        },
        userSwitchCountryLang: {
            deep: true,
            handler(newVal, oldVal) {
                this.init();
            },
        },
        isLogin: {
            deep: true,
            handler(newVal, oldVal) {
                this.getFixtureByLeagueData();
            },
        },
    },
    computed: {
        ...mapGetters([
            "isMobile",
            "currentLocale",
            "isLogin",
            "currentPathName",
            "userSwitchCountryLang",
            "isMobileRealTime",
        ]),
        ...mapState(["scrollTop"]),
    },
    created() {},
    beforeUnmount() {
        clearInterval(this.fixtureByLeagueDataInterval);
    },
    mounted() {
        this.leagueKey = this.$route.params.leagueKey;
        this.leagueId = this.$route.query.leagueId;
        this.subLeagueId = this.$route.query.subLeagueId;

        this.init();

        document.addEventListener("click", this.documentClick);
    },

    methods: {
        ...mapMutations(["SET_LEAGUE_SEASON_LIST"]),
        ...mapActions([
            "getFixtureByLeague",
            "getSoccerLeagueRanking",
            "getPastSoccerLeagueRanking",
            "getSoccerSubLeagueList",
            "getSeasonListByLeagueId",
            "addFavLeague",
            "unFavLeague",
            "favLoginTipsChangeEvent",
            "toastrFavChangeEvent",
            "getNewsListByLeague",
        ]),
        init() {
            this.handleMatchOptions(this.matchOptions[0], true); // default call upcomming data, and get pass subLeagueId from querystring
            this.initGetFixtureByLeagueDataInterval();
            // this.getAboutData();
            // if (!this.isMobile) {
            console.log('init')
            // this.getSoccerSubLeagueListData(); // get subleague data and bind to dropdown
            // }
            // ``;
            this.selectTabs(this.tabs[0]);
            this.setStandingFilterPill(true);
        },

        monthlyCalendarHandle(e, date, toggle, hideToggle) {
            toggle({ ref: e.target });

            hideToggleTarget = e.target;
            hideToggleElement = hideToggle;
        },

        dateSelected(e, date, toggle) {
            this.selected = date;
            toggle({ ref: e.target });
        },

        handleClearDate() {
            this.montlyCalender.selected = false;
            this.isShowClearBtn = false;
            this.montlyCalender.date = DATE;
            this.montlyCalender.dateValue = "";
        },

        // Mobile - set 'Matches > Results' filter pill
        setResultsFilterPill(toShow) {
            this.mobileResultsSeasonFilter.show = toShow;
        },
        // Mobile - set 'Matches > Standing' filter pill
        setStandingFilterPill(toShow) {
            this.mobileStandingSeasonFilter.show = toShow;
        },

        mobileFilterPillIsReady() {
            // WebApp - (Standings) Table
            if (this.currentTabs === 2)
                this.getSeasonListByLeagueIdData("standings");
        },

        //(Mobile) handle tabs
        selectTabs(o) {
            this.isShowLoading = true;
            if (this.isMobile) {
                this.tabs.forEach((x) => {
                    x.selected = false;
                });

                o.selected = true;
                this.currentTabs = o.id;
                if (o.child) {
                    this.currentTableTabs = o.child[0].id;
                }
                this.$refs.sticky4.checking();
                switch (o.id) {
                    case 1: //matches
                        this.handleReset();
                        this.currentChildMenus = this.matchesSubmenus;
                        console.log('init 2')
                        this.getSoccerSubLeagueListData();
                        break;
                    case 2: //table (standings)
                        this.handleReset();
                        this.tabs.forEach((tab) => {
                            if (tab.id === 2) {
                                this.currentChildMenus = tab.child;
                                this.selectChildMenu(
                                    this.currentChildMenus[0],
                                    this.currentChildMenus
                                );
                            }
                        });
                        this.getSeasonListByLeagueIdData("standings");
                        // this.getSoccerLeagueRankingData();
                        break;
                    case 3: //about
                        this.handleReset();
                        this.$refs.leagueNews.init();
                        break;
                    case 4: //stats
                        this.handleReset();
                        this.getSeasonListByLeagueIdData();
                        break;
                }

                if (![1, 2].includes(o.id)) {
                    this.currentChildMenus = [];
                }

                if (o.id !== 1) {
                    this.setResultsFilterPill(false);
                } else if (
                    o.id === 1 &&
                    this.selectedCurrentChildMenu === "results"
                ) {
                    this.setResultsFilterPill(true);
                }

                if (o.id !== 2) {
                    this.setStandingFilterPill(false);
                } else if (o.id === 2) {
                    this.setStandingFilterPill(true);
                }
            }
        },

        selectChildMenu(o, menuList) {
            menuList.forEach((x) => {
                x.selected = false;
            });

            o.selected = true;
            if (menuList !== this.matchesSubmenus) {
                this.currentTableTabs = o.id;
            } else if (menuList === this.matchesSubmenus) {
                this.selectedCurrentChildMenu = o.id;
                switch (o.id) {
                    case "fixtures": //matches
                        this.handleReset();
                        this.setResultsFilterPill(false);
                        this.getSoccerLeagueRankingData();
                        break;
                    case "results": //past seasons
                        this.handleReset();
                        this.setResultsFilterPill(true);
                        this.getSeasonListByLeagueIdData();
                        break;
                }
            }
        },

        selectPrimaryTabs(o) {
            if (mobileSelectSubLeague) {
                mobileSelectSubLeague.destroy();
            }
            if (mobileSelectSeason) {
                mobileSelectSeason.destroy();
            }
            if (o) {
            } else {
                o = this.primaryTabs[0];
            }
            this.primaryTabs.forEach((x) => {
                x.selected = false;
            });
            o.selected = true;
            this.currentPrimaryTabs = o.id;
            switch (o.id) {
                case 1: //matches
                    this.handleReset();
                    this.getSoccerLeagueRankingData();
                    break;
                // case 2: //past seasons
                //   this.handleReset();
                //   this.getSeasonListByLeagueIdData();
                //   break;
            }
        },
        //get about data
        // getAboutData() {
        //   if (typeof about[this.currentLocale] !== "undefined") {
        //     this.aboutContent = about[this.currentLocale][this.leagueKey];
        //     if (
        //       typeof this.aboutContent === "undefined" ||
        //       this.aboutContent === ""
        //     ) {
        //       this.isNoData = true;
        //     } else {
        //       this.isNoData = false;
        //     }
        //   } else {
        //     this.isNoData = true;
        //   }
        // },

        initGetFixtureByLeagueDataInterval() {
            if (this.fixtureByLeagueDataInterval) {
                clearInterval(this.fixtureByLeagueDataInterval);
            }
            this.fixtureByLeagueDataInterval = setInterval(() => {
                this.getFixtureByLeagueDataInterval();
            }, config.intervalMatchList);
        },

        getFixtureByLeagueDataInterval() {
            let selectedDate;

            if (
                this.montlyCalender.dateValue !== "" &&
                this.montlyCalender.dateValue !== DATE
            ) {
                selectedDate = moment(this.montlyCalender.dateValue).format(
                    this.apiParamDateFormat
                );
            } else {
                selectedDate = "";
            }

            let params = {
                leagueKey: this.leagueKey,
                type: this.type,
                matchDate: selectedDate,
                subLeagueId: this.currentSubLeague.subLeagueId,
                timeZone: this.$tools.getCurrentTimeZone(),
                isCallInterval: true,
            };
            this.isCallMatchContentInterval = true;
            this.$refs.matchContentChild.getMatchListData(params);
            //this.leagueListParams = params;
        },

        getFixtureByLeagueData(isGetSeasonData) {
            let selectedDate;
            if (
                this.montlyCalender.dateValue !== "" &&
                this.montlyCalender.dateValue !== DATE
            ) {
                selectedDate = moment(this.montlyCalender.dateValue).format(
                    this.apiParamDateFormat
                );
            } else {
                selectedDate = "";
            }

            let params = {};
            if (isGetSeasonData) {
                params = {
                    leagueKey: this.leagueKey,
                    type: 2,
                    timeZone: this.$tools.getCurrentTimeZone(),
                    season: this.currentSeasonList.name,
                };
                if (this.currentSubLeague.subLeagueId) {
                    params["subLeagueId"] = this.currentSubLeague.subLeagueId;
                }
                this.getPastSoccerLeagueRankingData(
                    this.currentSeasonList.name
                );
            } else {
                params = {
                    leagueKey: this.leagueKey,
                    type: this.type,
                    matchDate: selectedDate,
                    timeZone: this.$tools.getCurrentTimeZone(),
                    subLeagueId: this.currentSubLeague.subLeagueId,
                    isCallInterval: false,
                };
            }

            this.isCallMatchContentInterval = false;

            // params
            this.$refs.matchContentChild.getMatchListData(params);
            if (isGetSeasonData) {
                this.leagueListSeasonParams = params;
            } else {
                //this.leagueListParams = params;
            }
        },

        changeMatchContentFixtureByLeagueEvent(data) {
            if (data !== null) {
                // if (
                //   data.matchDateList === null &&
                //   this.isFirstTimeGetFixtureLeagueData
                // ) {
                //   //data.matchDateList === null
                //   this.handleMatchOptions(this.matchOptions[1]); // Go to "Most Recent" when "Upcoming" is empty AS-71
                // }
                // this.isFirstTimeGetFixtureLeagueData = false; //reset FirstTimeGetFixtureLeagueData status

                this.leagueInfo = data;
                this.leagueInfo.leagueName = data.leagueName || "";
                this.isFavLeague = this.leagueInfo.isFavLeague;

                // this.mobileHeaderTitle = this.leagueInfo.leagueName;
                this.mobileSubHeaderTitle = this.leagueInfo.country;

                if (!this.isCallMatchContentInterval) {
                    if (
                        this.currentPrimaryTabs === 1 &&
                        this.selectedCurrentChildMenu === "fixtures" &&
                        !this.isMobile
                    ) {
                        this.getSoccerLeagueRankingData();
                    }
                }
            }
        },

        async getSoccerLeagueRankingData() {
            this.isShowLoading = true;

            let params = {
                leagueIdList: this.leagueId,
            };

            const result = await this.getSoccerLeagueRanking(params);
            this.isShowLoading = false;

            if (result.result.length === 0) {
                this.isShowNoDataTable = true;
            } else {
                this.isShowNoDataTable = false;
                this.rankingTable.list = result.result;

                // this.generateStandingsFormList(this.rankingTable.list);
                this.handleLeagueListRankingTable();
            }
        },
        generateStandingsFormList(list) {
            list[0]["form"] = JSON.parse(JSON.stringify(list[0].total));
            list[0].form.forEach((x) => {
                x.promotionColor = null;
            });
        },

        // standings
        async getPastSoccerLeagueRankingData(season) {
            this.isShowLoading = true;

            let params = {
                leagueIdList: this.leagueId,
                season: season,
            };

            const result = await this.getPastSoccerLeagueRanking(params);

            if (result.result.length === 0) {
                this.isShowNoDataTable = true;
            } else {
                this.isShowNoDataTable = false;
                this.rankingTable.list = result.result;
                this.handleLeagueListRankingTable();
            }
            this.isShowLoading = false;
        },

        //get soccer subleague list
        async getSoccerSubLeagueListData() {
            let mobileSelectData = [];
            let mobileObj = {
                id: "",
                value: "",
            };
            let params = {
                leagueId: this.leagueId,
            };

            const result = await this.getSoccerSubLeagueList(params);

            if (result.result.length != 0) {
                this.subLeagueList.length = 1; //reset subLeagueList array and only keep first array;
                mobileObj.id = this.subLeagueList[0].subLeagueId;
                mobileObj.value = this.$i18n.t(
                    this.subLeagueList[0].subLeagueName
                );
                mobileSelectData.push(mobileObj);

                result.result.forEach((x) => {
                    // (Mobile) insert subleague data to mobile select
                    let mobileObj = {
                        id: "",
                        value: "",
                    };
                    mobileObj.id = x.subLeagueId;
                    mobileObj.value = x.subLeagueName;

                    mobileSelectData.push(mobileObj);

                    x.selected = false;

                    // (Dekstop) insert subleague data to desktop select
                    this.subLeagueList.push(x);

                    // selected data
                    if (x.subLeagueId === this.subLeagueId) {
                        let isFirstTimeLoadData = true;
                        this.handleSubLeagueDropdown(x, isFirstTimeLoadData);
                    }
                });

                //(Mobile) initial mobile subleague select
                if (this.isMobile) {
                    this.$nextTick(() => {
                        //store vue js this to that
                        let that = this;

                        let triggerId = "#subLeagueId";
                        let title = this.$i18n.t("SELECT_GROUP");
                        let ensureBtnText = this.$i18n.t("DONE");
                        let cancelBtnText = this.$i18n.t("CANCEL");

                        let ensureBtnColor =
                            "var(--color-text-primary-default)";
                        let titleBgColor = "#F0F0F0";

                        // if (mobileSelectSubLeague) {
                        // console.log('mobileSelectSubLeague', mobileSelectSubLeague)
                        //   mobileSelectSubLeague.destroy();
                        //   // return
                        // }
                        if (mobileSelectSubLeague) {
                         mobileSelectSubLeague.destroy();
                        }
                            console.log('mobile select sub league')
                        mobileSelectSubLeague = new MobileSelect({
                            trigger: triggerId,
                            triggerDisplayData: false,
                            triggerDisplayData: false,
                            title: title,
                            ensureBtnText: ensureBtnText,
                            cancelBtnText: cancelBtnText,
                            ensureBtnColor: ensureBtnColor,
                            titleBgColor: titleBgColor,

                            wheels: [
                                {
                                    data: mobileSelectData,
                                },
                            ],

                            callback: function (indexArr, data) {
                                that.currentSubLeague.subLeagueName =
                                    data[0].value;
                                that.currentSubLeague.subLeagueId = data[0].id;
                                if (that.currentSubLeague.subLeagueId === "") {
                                    that.currentSubLeague.colored = false;
                                } else {
                                    that.currentSubLeague.colored = true;
                                }
                                //	alert ("ss")
                                that.getFixtureByLeagueData();
                            },
                        });

                        if (
                            this.subLeagueId === null ||
                            typeof this.subLeagueId === "undefined"
                        ) {
                            // mobileSelectSubLeague.locatePosition(0, 0);
                        } else if (!that.isResetMatchOptions) {
                            for (let i = 0; i < mobileSelectData.length; i++) {
                                if (
                                    mobileSelectData[i].id === this.subLeagueId
                                ) {
                                    that.currentSubLeague.subLeagueName =
                                        mobileSelectData[i].value;

                                    that.currentSubLeague.colored = true;
                                    that.isResetMatchOptions = true;
                                    mobileSelectSubLeague.locatePosition(0, i);
                                }
                            }
                        }
                    });
                }
            } else {
                let isFirstTimeLoadData = true;
                this.handleSubLeagueDropdown(
                    this.subLeagueList[0],
                    isFirstTimeLoadData
                );
            }

            //(Desktop) if query string subleagueid is empty default pass 'All Groups' data to getFixturebyleague
            if (!this.isMobile) {
                if (
                    this.subLeagueId === null ||
                    typeof this.subLeagueId === "undefined"
                ) {
                    let isFirstTime = true;
                    this.handleSubLeagueDropdown(
                        this.subLeagueList[0],
                        isFirstTime
                    );
                }
            } else {
                // first time generate group title
                if (mobileSelectData.length > 0) {
                    this.currentSubLeague.subLeagueName =
                        mobileSelectData[0].value;
                }
            }
            this.isShowLoading = false;
        },

        //get getSeasonListData
        async getSeasonListByLeagueIdData(type = "default") {
            let params = {
                leagueId: this.leagueId,
            };

            let mobileSelectData = [];

            const result = await this.getSeasonListByLeagueId(params);
            result.result.forEach((x) => {
                x.selected = false;

                // (Mobile) insert subleague data to mobile select
                let mobileObj = {
                    id: "",
                    value: "",
                };
                mobileObj.id = x.season;
                mobileObj.value = x.season;

                mobileSelectData.push(mobileObj);
            });

            if (this.isMobile) {
                //(Mobile) initial mobile subleague select
                if (type === "default") {
                    this.mobileResultsSeasonFilter.content =
                        result.result[0].season.replace("-", "/");
                }
                if (type === "standings") {
                    this.mobileStandingSeasonFilter.content =
                        result.result[0].season.replace("-", "/");
                }
                this.$nextTick(() => {
                    //store vue js this to that
                    let that = this;

                    let triggerId =
                        type === "standings"
                            ? "#seasonListStandingsId"
                            : "#seasonListId";

                    let title = this.$i18n.t("SELECT_SEASON");
                    let ensureBtnText = this.$i18n.t("DONE");
                    let cancelBtnText = this.$i18n.t("CANCEL");

                    let ensureBtnColor = "var(--color-text-primary-default)";
                    let titleBgColor = "#F0F0F0";

                    if (type === "standings") {
                        mobileSelectData.unshift({
                            id: "null",
                            value: this.$i18n.t("SEASON"),
                        });
                        this.mobileStandingSeasonFilter.content =
                            this.$t("SEASONS");
                    }

                    if (mobileSelectSeason) {
                        mobileSelectSeason.destroy();
                    }

                    mobileSelectSeason = new MobileSelect({
                        trigger: triggerId,
                        triggerDisplayData: false,
                        triggerDisplayValue: false,
                        title: title,
                        ensureBtnText: ensureBtnText,
                        cancelBtnText: cancelBtnText,
                        ensureBtnColor: ensureBtnColor,
                        titleBgColor: titleBgColor,

                        wheels: [
                            {
                                data: mobileSelectData,
                            },
                        ],

                        callback: function (indexArr, data) {
                            that.currentSeasonList.name = data[0].value;
                            that.currentSeasonList.id = data[0].id;
                            if (type === "default") {
                                that.mobileResultsSeasonFilter.content =
                                    data[0].value.replace("-", "/");
                            }

                            // if (that.currentSeasonList.id === "null") {
                            //   that.currentSeasonList.colored = false;
                            // } else {
                            that.currentSeasonList.colored = true;
                            if (type === "standings") {
                            }
                            // }

                            if (type === "standings") {
                                if (that.currentSeasonList.id !== "null") {
                                    that.getPastSoccerLeagueRankingData(
                                        that.currentSeasonList.name
                                    );
                                } else {
                                    that.getSoccerLeagueRankingData();
                                }
                                that.mobileStandingSeasonFilter.content =
                                    that.currentSeasonList.name;
                            } else {
                                let isGetSeasonData = true;
                                that.getFixtureByLeagueData(isGetSeasonData);
                            }
                        },
                    });

                    //default first option value
                    this.currentSeasonList.name = mobileSelectData[0].value;
                    if (type === "standings") {
                        this.SET_LEAGUE_SEASON_LIST(this.currentSeasonList);
                    }
                    mobileSelectSeason.locatePosition(0, 0);

                    if (type === "standings") {
                        this.getSoccerLeagueRankingData();
                    } else {
                        let isGetSeasonData = true;
                        this.getFixtureByLeagueData(isGetSeasonData);
                    }
                });
            }
            this.seasonList = result.result;
            this.handleSeasonDropdown(this.seasonList[0]);
        },

        selectTableTabs(o) {
            this.tableTabs.forEach((x) => {
                x.selected = false;
            });
            o.selected = true;

            this.currentTableTabs = o.id;
        },

        //ranking table
        handleLeagueListRankingTable(action) {
            let limit = this.rankingTable.list.length - 1;
            let index = 0;

            if (limit === 0) {
                this.rankingTable.isShowArrow = false;
            } else {
                this.rankingTable.isShowArrow = true;
            }

            if (action === "next") {
                if (this.rankingTable.currentSelectedLeagueIndex < limit) {
                    this.rankingTable.currentSelectedLeagueIndex++;
                } else {
                    this.rankingTable.currentSelectedLeagueIndex = 0;
                }
                index = this.rankingTable.currentSelectedLeagueIndex;
            } else if (action === "prev") {
                if (this.rankingTable.currentSelectedLeagueIndex > 0) {
                    this.rankingTable.currentSelectedLeagueIndex--;
                } else {
                    this.rankingTable.currentSelectedLeagueIndex = limit;
                }

                index = this.rankingTable.currentSelectedLeagueIndex;
            } else {
                index = 0;
            }

            this.rankingTable.currentSelectedLeague =
                this.rankingTable.list[index].tableName;
            this.matchTableList = this.rankingTable.list[index];
            this.generateStandingsFormList(this.rankingTable.list);
        },

        handleMatchOptions(o, isFirstTimeLoadData) {
            this.matchOptions.forEach((x) => {
                x.selected = false;
            });
            o.selected = true;
            this.type = o.type;
            this.handleClearDate();

            if (isFirstTimeLoadData) {
                this.currentSubLeague.subLeagueId = this.subLeagueId;
            }

            this.getFixtureByLeagueData();
        },

        handleResetMatchOptions() {
            this.matchOptions.forEach((x) => {
                x.selected = false;
            });
            this.type = "";
        },

        //(Desktop) subLeague dropdown select event
        handleSubLeagueDropdown(o, isFirstime) {
            if (this.isMobile) {
                return;
            }
            this.subLeagueList.forEach((x) => {
                x.selected = false;
            });
            o.selected = true;

            this.currentSubLeague.subLeagueName = o.subLeagueName;
            this.currentSubLeague.isShowDropdown = false;
            this.currentSubLeague.subLeagueId = o.subLeagueId;

            if (this.currentSubLeague.subLeagueId === "") {
                this.currentSubLeague.colored = false;
            } else {
                this.currentSubLeague.colored = true;
            }

            //first time initial load dont call getFixtureByLeagueData
            if (!isFirstime) {
                if (this.selectedCurrentChildMenu === "fixture") {
                    this.getFixtureByLeagueData();
                } else {
                    this.getFixtureByLeagueData(this.currentSeasonList.name);
                    // this.getSoccerLeagueRankingData();
                }
            }
        },

        //(Desktop) Season dropdown select event
        handleSeasonDropdown(o) {
            if (this.isMobile) {
                return;
            }
            this.seasonList.forEach((x) => {
                x.selected = false;
            });
            o.selected = true;

            this.currentSeasonList.name = o.season;
            this.currentSeasonList.isShowDropdown = false;
            this.currentSeasonList.colored = true;
            this.mobileResultsSeasonFilter.content = o.season.replace("-", "/");
            this.SET_LEAGUE_SEASON_LIST(this.currentSeasonList);
            // this.currentSeasonList.subLeagueId = o.subLeagueId;

            // if (this.currentSeasonList.subLeagueId === '') {
            //     this.currentSeasonList.colored = false;
            // } else {
            //     this.currentSeasonList.colored = true;
            // }

            let isGetSeasonData = true;

            this.getFixtureByLeagueData(isGetSeasonData);
        },
        handleSubLeagueBtn(e) {
            this.currentSubLeague.isShowDropdown =
                !this.currentSubLeague.isShowDropdown;
            e.stopPropagation();
        },

        handleSeasonBtn(e) {
            this.currentSeasonList.isShowDropdown =
                !this.currentSeasonList.isShowDropdown;
            this.SET_LEAGUE_SEASON_LIST(this.currentSeasonList);
            e.stopPropagation();
        },

        documentClick(e) {
            //when click outsite document, the subleague dropdown will close
            this.currentSubLeague.isShowDropdown = false;
            this.currentSeasonList.isShowDropdown = false;
            this.SET_LEAGUE_SEASON_LIST(this.currentSeasonList);
            e.stopPropagation();
        },

        handleReset() {
            this.clearFixtureByLeagueDataInterval();
            if (this.isMobile) {
                // this.currentSubLeague.subLeagueName = this.subLeagueList[0].subLeagueName;
                this.currentSubLeague.subLeagueId =
                    this.subLeagueList[0].subLeagueId;
                this.isResetMatchOptions = true;
                if (this.currentSubLeague.subLeagueId === "") {
                    this.currentSubLeague.colored = false;
                } else {
                    this.currentSubLeague.colored = true;
                }
            } else {
                this.handleSubLeagueDropdown(this.subLeagueList[0], true);
            }
            this.isFirstTimeGetFixtureLeagueData = true;
            if (
                (this.currentPrimaryTabs === 1 &&
                    this.selectedCurrentChildMenu === "fixtures" &&
                    !this.isMobile) ||
                (this.currentTabs === 1 &&
                    this.selectedCurrentChildMenu === "fixtures" &&
                    this.isMobile)
            ) {
                this.handleMatchOptions(this.matchOptions[0]);
                this.initGetFixtureByLeagueDataInterval();
            }
        },

        async toggleFavLeague(data) {
            if (this.isLogin) {
                let params = {
                    leagueId: this.leagueInfo.leagueId,
                };
                let paramsToastr = {
                    isOpen: true,
                    msg: this.leagueInfo.leagueName,
                    isAddedFav: false,
                };
                if (!!this.isFavLeague) {
                    const result = await this.unFavLeague(params);
                    if (result.message === "Success") {
                        this.isFavLeague = false;

                        paramsToastr.isAddedFav = false;
                        this.toastrFavChangeEvent(paramsToastr);
                    }
                } else {
                    const result = await this.addFavLeague(params);
                    if (result.message === "Success") {
                        this.isFavLeague = true;

                        paramsToastr.isAddedFav = true;
                        this.toastrFavChangeEvent(paramsToastr);
                    }
                }
            } else if (!this.isLogin && !this.isMobile) {
                // this.favLoginTipsChangeEvent({
                //   isOpen: true,
                //   event: data,
                //   callBackUrl: this.currentPathName,
                // });
                this.$refs.PopUpSignInIndexMobileRef.handleOpen();
            } else if (!this.isLogin && this.isMobile) {
                this.$refs.PopUpSignInIndexMobileRef.handleOpen();
            }
        },

        handleAuthentication(type) {
            this.popUpSignInModuleEvent(type);
            this.$refs.PopUpSignInIndexMobileRef.handleClose();
        },

        clearFixtureByLeagueDataInterval() {
            if (this.fixtureByLeagueDataInterval) {
                clearInterval(this.fixtureByLeagueDataInterval);
            }
        },
    },
};
</script>
<style scoped>
.match-content__wrapper.league {
    padding: 0;
}
.match-table-container {
    background-color: var(--color-background-default-secondary);
    width: calc(568px - 32px);
    padding: 16px;
    border-radius: 16px;
}
.tab-wrapper {
}
.home-match__title.fav-icon {
    margin-left: auto;
}
.home-match__title.fav-icon img {
    height: 40px;
}
.btn-fav-circle {
    margin-left: auto;
    width: 40px;
    height: 40px;
}
.btn-fav {
    width: 22px;
    height: 22px;
}
.nav-pill__wrapper {
    padding: 0 8px 8px 0px;
    box-sizing: border-box;
    margin-right: 0 !important;
}
.nav-pill__wrapper.filter-pill {
    padding: 0;
    overflow: visible;
}
.nav-pill__wrapper.filter-pill .nav-pill.selected {
    margin: 0;
    min-height: 34px;
    padding: 0 16px;
    /* color: var(--color-text-default-default) !important;
  border: 1px solid var(--color-border-default-default) !important;
  background: var(--color-background-default-secondary) !important; */
}
.nav-pill__wrapper.filter-pill .nav-pill svg path {
    fill: var(--color-text-default-default);
}
.match-table__header .nav-pill__wrapper {
    margin-top: 16px;
    margin-bottom: 16px;
}
.match-table__header .nav-pill__wrapper .nav-pill {
    border: 1px solid var(--color-border-default-default);
    border-radius: var(--size-radius-600);
    padding: 8px 24px;
    color: var(--color-text-default-default);
}
.match-table__header .nav-pill__wrapper .nav-pill.selected {
    border: 1px solid var(--bg-selected) !important;
}

.sub-nav__child .nav-pill:last-child {
    margin-right: 0 !important;
}
.home {
}
.league-header {
    background: var(--color-background-default-secondary);
    margin-bottom: 24px;
    padding: 24px 30.4px 0;
    border-radius: var(--size-radius-400);
}
.league-title {
    font-size: 32px;
    line-height: 120%;
    font-family: var(--weight-600);
    letter-spacing: -0.64px;
    margin: 0;
    color: var(--color-text-default-default);
}
.league-title__country {
    font-size: 16px;
    color: var(--color-text-default-secondary);
    margin-top: 4px;
    letter-spacing: 0.64px;
}
.league-about__container {
    padding: 1rem;
}
.league-about__title {
    font-size: 0.88rem;
    margin-bottom: 0.5rem;
}
.league-about__content {
    font-size: 11.2px;
    line-height: 1rem;
    color: var(--color-grey-light);
}
.league-matchtabs__wrapper {
    overflow-x: auto;
    background-color: red;
}
.league-matchtabs__seperator {
    width: 0.1rem;
    height: 1.4rem;
    background-color: #ffffff;
    margin: 0.1rem 0.5rem 0rem 0.2rem;
}
.league-matchtabs__seperator::after {
    content: "";
    width: 0.1rem;
    height: 1.4rem;
    background-color: #ffffff;
    margin: 0.1rem 0.5rem 0rem 0.2rem;
}
.league-matchtabs__reset {
    cursor: pointer;
    font-size: 0.875rem;
    font-family: var(--weight-700);
    color: var(--bg-selected);
}
.league-dropdown__svg {
    fill: white;
}
.league-header__wrapper {
    display: flex;
    justify-content: start;
    align-items: center;
    margin: 0rem 0 1.5rem;
    padding: 8px 0 0 0;
}
.selected .league-dropdown__svg {
    fill: black;
}

.match-table__header {
    /* margin: 1.1rem 0 0rem; */
    margin: 0rem 0 0rem;
}
.match-filter {
    display: flex;

    margin: 1rem 0;
}
.match-filter__child {
    color: white;
    border: 1px solid white;
    border-radius: 1rem;
    padding: 0.4rem 1.1rem;
    margin-right: 1rem;
    cursor: pointer;
    font-size: 14.4px;
}

.match-table__title-wrapper {
    display: flex;
    justify-content: space-between;
    font-size: 0.88rem;
    margin-bottom: 0.5rem;
}
.match-table__title-country {
    display: flex;
    width: calc(100% - 4rem);
    line-height: 1rem;
}
.match-table__title-country-container {
    transition: all 0.3s;
    min-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 11.2px;
    text-align: center;
    color: var(--color-text-default-default);
}
.match-table__title-arrow__wrapper {
    width: 2rem;
    text-align: center;
    cursor: pointer;
    fill: white;
}
.match-table__title-arrow__wrapper:hover .match-table__title-arrow__icon {
    fill: var(--color-hover);
}
.match-table__title-arrow__wrapper.tl {
    /* text-align: left; */
}
.capitalize {
    text-transform: capitalize;
}

.sub-nav__child {
    padding-right: 0;
}
.sub-nav__child .nav-pill {
    width: 100%;
    color: var(--color-text-default-default);
    padding: 8px 16px;
    border: 1px solid var(--color-border-default-default);
}
.league-container-title {
    color: var(--color-text-default-default);

    /* Body Strong */
    font-family: var(--typography-body-font-family);
    font-size: var(--typography-body-size-large);
    font-style: normal;
    font-family: var(--weight-600);
    line-height: 140%; /* 22.4px */
    letter-spacing: 0.64px;
    margin-bottom: 1rem;
}
.league-match-listing-container {
    width: 38rem;
    padding: var(--size-space-400);
    border-radius: 16px;
    background: var(--color-background-default-secondary);
    box-sizing: border-box;
    margin-right: 1.5rem;
}
.league-icon {
    width: 83.35px;
    height: auto;
}

@media(max-width: 768px) {
    /* for test */
    .league-header {
        padding: 0 8px;
        border-radius: 0;
        padding-bottom: 16px;
        margin-bottom: 0;
    }
    .league-header__wrapper {
        margin-bottom: 0;
    }
    .league-header.league-3,
    .nav-3 {
        margin-bottom: 0 !important;
    }
    .league-tab-1,
    .league-tab-2,
    .league-tab-4 {
        gap: 16px;
        margin-bottom: 8px !important;
        /* margin-top: 0; */
    }
    .league-tab-3 {
        margin-bottom: 0;
        gap: 16px;
    }
    /* .scroll_top_nav .league-tab-3 {
    
    margin-bottom: 0 !important;
    padding-top: 1rem;
  } */
    .sub-nav__child {
        margin-left: 0;
        margin-right: 0;
    }
    .sub-nav__child-indicator {
        margin-top: 16px;
    }
    .league-about__container {
        padding: 0;
    }
    .nav-pill-group-divider {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1px;
        height: 1.5rem;
        margin-right: 0.5rem;
        background: #ffffff;
    }
    .nav-pill__wrapper {
        padding-left: 8px;
        padding-right: 8px;
        white-space: nowrap;
        overflow: auto;
        margin: 0;
    }
    .nav-pill__wrapper.filter-pill {
        padding: 0 8px;
    }
}

.scroll_top_logo {
    left: 50%;
    transform: translateX(-50%);
    top: 2px;
    position: relative;
}

.scroll_top_fav {
    top: 4px;
    right: 8px;
}
.date-picker-container {
    background-color: red;
    width: 85px;
    height: 26px;
}
.standing-title {
    font-family: var(--weight-600);
    letter-spacing: 0.64px;
    color: var(--color-text-default-default);
}

.match-content__wrapper {
    padding: 0 8px;
}
.btn-fav-aspn {
    width: 22.83px;
    height: 21.8px;
}
.season-button {
    padding: 8px 16px 8px 21px;
}

@media(max-width: 768px) {
    /* for test */
    .scroll_top_nav {
        top: 45px;
        border-bottom: 1px solid var(--color-border-default-default);
        width: 100%;
        background: var(--color-background-default-secondary);
        left: 0;
    }
    .home {
        min-height: calc(100% - 151px);
        height: auto;
    }
    .league-matchtabs__wrapper {
        background-color: transparent;
        margin-bottom: 8px;
    }
    .league-matchtabs__wrapper .nav-pill {
        width: 100%;
        padding: 5px 16px;
    }
    .scroll_top_nav {
        margin-bottom: 8px;
        background-color: var(--color-background-default-secondary);
    }
    .home-nav__containers {
        padding-bottom: 78px;
    }
    .nav-pill-wrapper svg {
    pointer-events: none;
    }
}
</style>

<style>
.scroll_top_logo_size {
    width: 44px;
    height: 44px;
}
.league-header__wrapper .icon-league {
    width: 40px;
    height: 40px;
}
@media(max-width: 768px) {

    #subLeagueId {
        background-color: var(--color-background-default-secondary);
    }
}
</style>
